import { useState } from 'react';
import PropTypes from 'prop-types';
import { Stack, styled } from '@mui/material';
import { useDispatch } from 'react-redux';
import Image from '../../../components/Image';
import useLocales from '../../../hooks/useLocales';
import LanguagePopover from '../header/LanguagePopover';
import { openLoginSignup } from '../../../redux/slices/authPages';
import Iconify from '../../../components/Iconify';
import { useLangNavigate } from '../../../hooks/useLangNavigate';

// STYLES
const BottomNavContainer = styled(Stack)(({ isAuthenticated }) => ({
  height: '64px',
  position: 'fixed',
  bottom: 0,
  left: 0,
  zIndex: 100,
  right: 0,
  fontWeight: 'bold',
  backgroundColor: '#094221',
  fontSize: isAuthenticated ? '12px' : '16px',
}));

const BottomNav = styled(Stack)(({ position }) => ({
  cursor: 'pointer',
  color: '#fff',
  fontSize: 10,
  fontWeight: 400,
}));

// STYLES

// ----------------------------------------------------------------------
MobileBottomNav.propTypes = {
  isAuthenticated: PropTypes.bool,
};

export default function MobileBottomNav({ isAuthenticated, setOpenAccountDrawer, tawkRef }) {
  const navigate = useLangNavigate();

  const { translate } = useLocales();

  const dispatch = useDispatch();

  return (
    <>
      <BottomNavContainer direction={'row'} isAuthenticated={isAuthenticated}>
        <BottomNav flex={1} justifyContent="center" alignItems="center" onClick={() => navigate('/')}>
          <Iconify icon={'carbon:home'} sx={{ height: '25px', width: '25px' }} />
          {translate('home')}
        </BottomNav>
        <BottomNav
          flex={1}
          justifyContent="center"
          alignItems="center"
          onClick={() =>
            isAuthenticated ? navigate('/referral') : dispatch(openLoginSignup({ open: true, isLogin: true }))
          }
        >
          <Iconify icon={'octicon:people-24'} sx={{ height: '25px', width: '25px' }} />
          {translate('referral')}
        </BottomNav>
        <BottomNav flex={1} justifyContent="center" alignItems="center" onClick={() => navigate('/promotion')}>
          <Iconify icon={'qlementine-icons:gift-16'} sx={{ height: '25px', width: '25px' }} />
          {translate('promotions')}
        </BottomNav>
        <BottomNav
          flex={1}
          justifyContent="center"
          alignItems="center"
          onClick={() => (tawkRef?.current ? tawkRef?.current?.toggle() : {})}
        >
          <Iconify icon={'bx:chat'} sx={{ height: '25px', width: '25px' }} />
          {translate('livechat')}
        </BottomNav>
        <BottomNav
          flex={1}
          justifyContent="center"
          alignItems="center"
          onClick={() => {
            if (!isAuthenticated) dispatch(openLoginSignup({ open: true, isLogin: true }));
            else navigate('user/setting');
            // else navigate('/user/account');
          }}
        >
          <Iconify icon={'akar-icons:person'} sx={{ height: '25px', width: '25px' }} />
          {translate('account')}
        </BottomNav>
      </BottomNavContainer>
    </>
  );
}
